export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 76 76" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-922.000000, -4926.000000)">
                    <g id="编组-2" transform="translate(510.000000, 4798.000000)">
                        <g id="Laptop_icon" transform="translate(412.000000, 128.000000)">
                            <rect id="矩形备份-22" x="0" y="0" width="76" height="76"></rect>
                            <g
                                id="编组-37"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                transform="translate(8.000000, 16.000000)"
                                stroke="#000000"
                                strokeWidth="2"
                            >
                                <path
                                    d="M4.33889651,39.9149245 L4.33889651,3.07163525 C4.33889651,1.37548738 5.66204962,0 7.29468318,0 L57.5207147,0 C59.1533483,0 60.4765013,1.37548738 60.4765013,3.07163525 L60.4765013,39.9149245"
                                    id="Stroke-147"
                                ></path>
                                <path
                                    d="M64.0070145,48 L0.992985449,48 C0.444360989,48 0,47.538352 0,46.9683844 L4.33889651,40.4973849 L60.5520195,40.4973849 L65,46.9683844 C65,47.538352 64.5556389,48 64.0070145,48 Z"
                                    id="Stroke-148"
                                ></path>
                                <line x1="31.562885" y1="5.00952447" x2="34.2623519" y2="5.00952447" id="路径-6"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
